/* eslint-disable react/destructuring-assignment,react/jsx-indent,react/jsx-closing-tag-location,one-var,react/no-unused-state,no-param-reassign,no-param-reassign */
import React, { Component } from 'react';
import { Row, Col, Checkbox, message, Spin, Button } from 'antd';
import NickNameModal from './components/EditNickNameModal';
import ShowDemoModal from './components/ShowDemoModal';
import Container from '@/components/Container';
import AcademicYear from './components/AcademicYear';
import AcademicYearModal from './components/AcademicYearModal';
import { getUserInfo } from '../../SurveyStatistics/fetchUserInfoTest'; // 新用户信息接口
import { request } from '../../SurveyStatistics/controller';
import concatImg from '../../../../assets/contacts/setting/codeImg.jpg';
import schoolLog from '../../../../assets/contacts/setting/schoolLog.jpg';
import DefaultCode from '../../../../assets/contacts/setting/default_code.png';
import style from './index.less';

const orgIdArr = [];
const CONFIG_KEY_TEACHER_VIEW = 'comunicatebook.teacher.view',
  CONFIG_KEY_STUDENT_REGISTER_NOCHECK = 'student.register.nocheck',
  CONFIG_KEY_COURSE_WEEKEND = 'course.weekend',
  CONFIG_KEY_CLASS_OF_A_DAY = 'course.daycount';
const optionData = [
  { key: 0, value: 'key1', text: '允许查看所有教师通讯录' },
  { key: 1, value: 'key2', text: '允许查看本部门教师通讯录' },
  { key: 2, value: 'key3', text: '不允许查看教师通讯录' },
];
const optionDataTwo = [
  { key: 0, value: 'key4', text: '4节' },
  { key: 1, value: 'key5', text: '5节' },
  { key: 2, value: 'key6', text: '6节' },
  { key: 3, value: 'key7', text: '7节' },
  { key: 4, value: 'key8', text: '8节' },
  { key: 5, value: 'key9', text: '9节' },
  { key: 6, value: 'key10', text: '10节' },
  { key: 7, value: 'key11', text: '11节' },
  { key: 8, value: 'key12', text: '12节' },
  { key: 9, value: 'key13', text: '13节' },
  { key: 10, value: 'key14', text: '14节' },
  { key: 11, value: 'key15', text: '15节' },
];

let registerApi, oldOpenPlatformApi, shortNameApi;
function changeAPI() {
  const env = document.querySelector('meta[name=x-server-env]').content || 'test';
  if (env === 'production') {
    registerApi = '//register.api.xiaoyuanhao.com/sh-app';
    oldOpenPlatformApi = '//user.api.xiaoyuanhao.com';
    shortNameApi = '//gateway.api.xiaoyuanhao.com/contacts';
  } else {
    // 测试的时候， 这个不起作用。 jinfeng说这个接口平时不启动。所以用正式环境
    registerApi = '//test-deploy.api.xiaoyuanhao.com/sh-app-qa'
    oldOpenPlatformApi = '//aly-test.api.xiaoyuanhao.com/sh-user-center-test';
    shortNameApi = '//aly-test.api.xiaoyuanhao.com/cloud-contacts-test';
  }
}

changeAPI();

export default class BasicSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      schoolName: '',
      schoolLogo: '',
      qr_code: '',
      dimension: '',
      value: '',
      valueTwo: '',
      isChecked: 0,
      loadding: true,
      isCheckedTwo: 0,
      qrCode: '',
      registerChecked: '',
      registerTeacherChecked: '',
      registerSchoolChecked: '',
      registerStudentChecked: '',
      showStudentRegister: false,
      academicYearInfo: [], // 学年信息列表
      academicYearModalState: false, // 添加学年弹出框 显示状态
      reviseAcademicYearInfo: [], // 需要修改的学年信息
      isReviseAcademicYearInfo: false, // 设置学年弹出框是否为修改状态
      showDemoModal: false,
      showEditModal: false,
      shortName: '',
      orgId: '',
      userInfo: {}
    };
  }

  componentWillMount() {
    request({
      url: `${registerApi}/register/pc/shRegisterConfig/getConfig`,
    }).then(result => {
      const obj = result.content || {};
      this.setState({
        registerChecked: obj.check_class_master_info === 'true', // 是否需要班主任审核
        registerTeacherChecked: obj.teacher_register_able === 'true', // 老师自主注册
        registerSchoolChecked: obj.alumni_register_able === 'true', // 校友自主注册
      });
      // 学生自主注册
      if (obj.showStudentRegister) {
        this.setState({
          showStudentRegister: true,
          registerStudentChecked: obj.student_self_register_able === 'true',
        });
      }
    });

    this.getSchoolYear();

    const changeInfo = userInfo => {
      orgIdArr.push(userInfo.orgId);
      this.setState({
        schoolName: userInfo.orgName,
        schoolLog: `//classpic.oss-cn-hangzhou.aliyuncs.com/avatar/${userInfo.orgId}.jpg` || schoolLog,
        qr_code: `//classpic.oss-cn-hangzhou.aliyuncs.com/parent/qrCode/${userInfo.orgId}.jpg`,
        orgId: userInfo.orgId,
        userInfo,
      });
      this.initialStatus(userInfo.orgId);
    };
    getUserInfo(changeInfo);
  }

  componentDidMount() {
    this.loadCodeImg();
    request({
      url: `//${shortNameApi}/org/pc/shortName`,
    }).then(res => {
      if (res.code === 0) {
        this.setState({
          shortName: res.shortName,
        });
      } else {
        message.error(res);
      }
    })
  }

  onChange(e) {
    const isChecked = e.target.checked;
    this.setState({
      isChecked,
    });
    this.saveConfigToRemote(orgIdArr[0], CONFIG_KEY_STUDENT_REGISTER_NOCHECK, !isChecked);
  }

  onChangeTwo(e) {
    const isCheckedTwo = e.target.checked;
    this.setState({
      isCheckedTwo,
    });

    this.saveConfigToRemote(orgIdArr[0], CONFIG_KEY_COURSE_WEEKEND, isCheckedTwo);
  }

  // 学期学年数据添加和更新
  onAcademicYearSubmit(formData) {
    request({
      url: `//${oldOpenPlatformApi}/internal/v2/schoolYear/addUpdate`,
      method: 'post',
      params: formData,
    })
      .then(() => {
        this.getSchoolYear();
        this.setAcademicYearModalVisible(false);
      })
      .catch(err => {
        console.log(2, err);
      });
  }

  // 设置学年modal显示状态
  setAcademicYearModalVisible(state, isReviseAcademicYearInfo, reviseAcademicYearInfo) {
    if (isReviseAcademicYearInfo === undefined || !isReviseAcademicYearInfo) {
      isReviseAcademicYearInfo = false;
    }

    // 清除修改操作的传值缓存
    if (!state || !reviseAcademicYearInfo) {
      reviseAcademicYearInfo = [];
    }

    this.setState({
      academicYearModalState: state,
      isReviseAcademicYearInfo,
      reviseAcademicYearInfo,
    });
  }

  // 获取学年信息
  getSchoolYear() {
    request({
      url: `${oldOpenPlatformApi}/internal/v2/schoolYear/get`,
    })
      .then(result => {
        if (result.schoolYearList && result.schoolYearList.length >= 0) {
          this.setState({
            academicYearInfo: result.schoolYearList,
          });
        }
      })
      .catch(result => {
        console.log('academicYear_catch', result);
      });
  }

  // 删除学年信息
  delSchoolYear(id) {
    request({
      url: `${oldOpenPlatformApi}/internal/v2/schoolYear/delete`,
      method: 'post',
      params: { schoolYearId: id },
    })
      .then(result => {
        console.log('delSchoolYear-result', result);
        this.getSchoolYear();
      })
      .catch(err => {
        console.log('delSchoolYear-err', err);
      });
  }

  showModal() {
    this.setState({
      visible: true,
    });
  }

  // 设置需要修改的学年信息
  reviseAcademicYear(reviseAcademicYearInfo) {
    if (reviseAcademicYearInfo !== undefined) {
      this.setState({
        reviseAcademicYearInfo,
      });

      this.setAcademicYearModalVisible(true, true, reviseAcademicYearInfo);
    }
  }

  handleCancle() {
    this.setState({
      visible: false,
    });
  }

  // 初始化配置，如果没有设置过，使用默认值
  initialStatus(orgId) {
    request({
      url: `//${oldOpenPlatformApi}/open/change/interface/key`,
      params: {
        orgId,
      },
    }).then(res => {
      let [teacherViewCfgVal, studentRegisterNeedCheck, haveCourseInWeekend, classCountOfDay] = [
        0,
        true,
        false,
        5,
      ];

      res.forEach(child => {
        switch (child.cfgKey) {
          case CONFIG_KEY_TEACHER_VIEW:
            teacherViewCfgVal = Number.parseInt(child.cfgVal) || teacherViewCfgVal;
            break;
          case CONFIG_KEY_STUDENT_REGISTER_NOCHECK:
            studentRegisterNeedCheck = child.cfgVal === 'false';
            break;
          case CONFIG_KEY_COURSE_WEEKEND:
            haveCourseInWeekend = child.cfgVal === '是';
            break;
          case CONFIG_KEY_CLASS_OF_A_DAY:
            classCountOfDay = Number.parseInt(child.cfgVal) || classCountOfDay;
            break;
        }
      });

      this.setState({
        loadding: false,
        value: optionData[teacherViewCfgVal].text,
        isChecked: studentRegisterNeedCheck,
        isCheckedTwo: haveCourseInWeekend,
        valueTwo: optionDataTwo[classCountOfDay - 4].text,
      });
    });
  }

  loadCodeImg() {
    request({
      url: `//${oldOpenPlatformApi}/open/change/picture/two`,
    }).then(data => {
      this.setState({
        dimension: data || concatImg,
      });
    });
    request({
      url: `${registerApi}/register/pc/shRegisterInformation/qrCode`,
    }).then(data => {
      this.setState({ qrCode: data.content });
    });
  }

  // 选择权限
  selectTxt(value, key, txt, e) {
    const map = {
      key1: 0,
      key2: 1,
      key3: 2,
    };
    const type = map[value];
    this.setState({
      value: txt,
    });
    this.saveConfigToRemote(orgIdArr[0], CONFIG_KEY_TEACHER_VIEW, type);
  }

  // 选择每周课程数
  selectClassNum(value, key, txt, e) {
    const map = {
      key4: 4,
      key5: 5,
      key6: 6,
      key7: 7,
      key8: 8,
      key9: 9,
      key10: 10,
      key11: 11,
      key12: 12,
      key13: 13,
      key14: 14,
      key15: 15,
    };
    this.setState({
      valueTwo: txt,
    });
    this.saveConfigToRemote(orgIdArr[0], CONFIG_KEY_CLASS_OF_A_DAY, map[value]);
  }

  // 验证老师姓名或手机号开关
  registerChange(e) {
    const isOn = e.target.checked;
    this.setState({ registerChecked: isOn });
    const url = `${registerApi}/register/pc/shRegisterConfig/${
      isOn ? 'enable' : 'disable'
      }CheckClassMasterInfo`;
    request({
      url,
      method: 'post',
      params: {},
    }).then(_ => _);
  }

  // 老师自主注册开关
  registerTeacherChange(e) {
    this.setState({ registerTeacherChecked: e.target.checked });
    if (e.target.checked) {
      request({
        url: `${registerApi}/register/pc/shRegisterConfig/enableTeacherRegisterAble`,
        method: 'post',
        params: {},
      }).then(() => { });
    } else {
      request({
        url: `${registerApi}/register/pc/shRegisterConfig/disableTeacherRegisterAble`,
        method: 'post',
        params: {},
      }).then(() => { });
    }
  }

  // 学生自主注册开关
  registerStudentChange(e) {
    this.setState({ registerStudentChecked: e.target.checked });
    if (e.target.checked) {
      request({
        url: `${registerApi}/register/pc/shRegisterConfig/enableStudentSelfRegisterAble`,
        method: 'post',
        params: {},
      }).then(() => { });
    } else {
      request({
        url: `${registerApi}/register/pc/shRegisterConfig/disableStudentSelfRegisterAble`,
        method: 'post',
        params: {},
      }).then(() => { });
    }
  }

  // 校友自主注册开关
  registerSchoolChange(e) {
    this.setState({
      registerSchoolChecked: e.target.checked
    });

    request({
      url: `${registerApi}/register/pc/shRegisterConfig/${e.target.checked ? 'enableAlumniRegisterAble' : 'disableAlumniRegisterAble'}`,
      method: 'post',
      params: {},
    }).then(() => { });
  }

  saveConfigToRemote(orgId, cfgKey, value) {
    if (cfgKey === CONFIG_KEY_COURSE_WEEKEND) {
      value = value ? '是' : '否';
    }

    const url = `//${oldOpenPlatformApi}/open/change/interface/update?orgId=${orgId}&cfgKey=${cfgKey}&cfgValue=${value}`;
    request({
      url,
    }).then(() => { });
  }

  handleToggleEditModal = (showEditModal) => {
    this.setState({
      showEditModal,
    })
  }

  handleToggleDemoModal = (showDemoModal) => {
    this.setState({
      showDemoModal,
    });
  }

  handleSubmit = (value) => {
    // 获取表单value 调后端接口
    this.setState({
      shortName: value,
    });
    this.handleToggleEditModal(false)
  }

  render() {
    const {
      academicYearInfo,
      academicYearModalState,
      reviseAcademicYearInfo,
      isReviseAcademicYearInfo,
    } = this.state;

    let qrCode_info = '校园号自主注册二维码';

    const { location } = window;
    const { host } = location;
    if (host.indexOf('wxy') > -1) {
      qrCode_info = '沃学云自主注册二维码';
    } else if (host.indexOf('xhjy') > -1) {
      qrCode_info = '新和教育自主注册二维码';
    }
    const { showDemoModal, showEditModal, shortName, orgId, userInfo } = this.state;
    const { qr_code, dimension, qrCode } = this.state || {};
    return (
      <Container breStates={!0} version={2}>
        <div className={style.main}>
          <Spin spinning={this.state.loadding}>
            <div className="schoolBasicInfo">
              <p className="title">基本资料</p>
              <div className="basicResource">
                <Row style={{ marginBottom: 28 }}>
                  <Col span={3}>名称：</Col>
                  <Col>{this.state.schoolName}</Col>
                </Row>
                <Row style={{ marginBottom: 28 }}>
                  <Col span={3}>ID：</Col>
                  <Col>{orgId}</Col>
                </Row>
                <Row style={{ marginBottom: 28 }}>
                  <Col span={3}>简称：</Col>
                  <Col>
                    {
                      shortName ? <div>
                        <div>{shortName}</div>
                        <Row>
                          <Col span={3} />
                          <Button className='setting-button' onClick={() => this.handleToggleEditModal(true)}> 修 改</Button>
                        </Row>
                      </div> : <Button className='setting-button-set' onClick={() => this.handleToggleEditModal(true)}> 设 置</Button>
                    }
                  </Col>
                  <Col span={3} />
                  <Col>
                    <span style={{ color: '#aaaaaa' }}>说明: 设置后的简称将在应用中进行展示 </span>
                    <a onClick={() => this.handleToggleDemoModal(true)}>查看展示效果</a>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 28 }}>
                  <Col span={3}>Logo：</Col>
                  <Col>
                    <img alt='' src={this.state.schoolLog} />
                  </Col>
                  <Col span={3} />
                  <Col>
                    <span style={{ color: '#aaaaaa', marginTop: 12, display: 'inline-block' }}>说明: 请前往【企业微信后台】-【我的企业】-【微信插件】处进行修改。 </span>
                  </Col>
                </Row>
                {
                  userInfo && userInfo.enOrgType == "general_school" && <Row style={{ marginBottom: 28 }}>
                    <Col span={3}>二维码：</Col>
                    <Col span={5} style={{ display: 'flex' }}>
                      <div className='qr-code-container'>
                        <div className='code-img-wrap'>
                          <img alt='' className="code-img" src={!qr_code ? DefaultCode : qr_code} />
                        </div>
                        <div className='qr-code-info'>
                          <span>家长关注二维码</span>
                          <span
                            className="down"
                            onClick={this.showModal.bind(this)}
                          >
                            <a
                              href={qr_code}
                              download="二维码"
                              data-category="download codeImg"
                              data-action="click"
                              data-label="下载"
                            >下载</a>
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                }

              </div>
              {/* <div className="functionSetting">
                <p className="title">功能设置</p>
                <div className="functionInfo">
                  <Row type="flex" style={{ marginBottom: 40, position: 'relative' }}>
                    <Col span={3}>家长身份审核</Col>
                    <Col>
                      <Checkbox
                        onChange={this.onChange.bind(this)}
                        data-category="check_identify"
                        data-action="click"
                        data-label={this.state.isChecked}
                        checked={this.state.isChecked}
                      >
                        自主注册后需要班主任进行身份审核
                      </Checkbox>
                      <p className="notice">
                        <span className="star">*</span>系统将根据设置决定是否自动审核通过
                      </p>

                      <div style={{ 'margin-top': '27px' }}>
                        <Checkbox
                          onChange={this.registerChange.bind(this)}
                          checked={this.state.registerChecked}
                        >
                          自主注册后需要验证老师姓名或者手机号
                        </Checkbox>
                      </div>

                      <div style={{ 'margin-top': '3px' }}>
                        <Checkbox
                          onChange={this.registerTeacherChange.bind(this)}
                          checked={this.state.registerTeacherChecked}
                        >
                          允许老师自主注册
                        </Checkbox>
                      </div>
                    </Col>
                  </Row>
                  {this.state.showStudentRegister ? (
                    <Row type="flex" style={{ marginBottom: 40, position: 'relative' }}>
                      <Col span={3}>学生自主注册</Col>
                      <Col>
                        <Checkbox
                          onChange={this.registerStudentChange.bind(this)}
                          checked={this.state.registerStudentChecked}
                        >
                          允许学生自主注册
                        </Checkbox>
                      </Col>
                    </Row>
                  ) : null}
                  <Row type="flex" style={{ marginBottom: 40, position: 'relative' }}>
                    <Col span={3}>学年设置</Col>
                    <Col>
                      <a onClick={this.setAcademicYearModalVisible.bind(this, true)}>+ 添加新学年</a>
                      <AcademicYear
                        academicYearInfo={academicYearInfo}
                        delSchoolYear={this.delSchoolYear.bind(this)}
                        reviseAcademicYear={this.setAcademicYearModalVisible.bind(this)}
                      />
                    </Col>
                  </Row>
                </div>
              </div> */}
            </div>
          </Spin>
          <AcademicYearModal
            key='year-modal'
            visible={academicYearModalState}
            info={reviseAcademicYearInfo}
            isRevise={isReviseAcademicYearInfo}
            onModelOk={this.onAcademicYearSubmit.bind(this)}
            onModelCancel={this.setAcademicYearModalVisible.bind(this)}
          />
          {showEditModal &&
            <NickNameModal
              onOk={this.handleSubmit}
              shortName={shortName}
              onCancel={() => this.handleToggleEditModal(false)}
            />
          }
          {showDemoModal &&
            <ShowDemoModal
              onCancel={() => this.handleToggleDemoModal(false)}
            />}
        </div>
      </Container>
    );
  }
}
